import _pt from 'prop-types';
import 'react';
import { jsx } from '@emotion/core';
import { observer } from 'mobx-react';
import { withStores } from "../contexts/StoresContext.js";
import useStores from "../hooks/useStores.js";
import { Fillable } from "../contexts/AnnotationContext.js";
import PdfDocument from "../components/PdfDocument.js";
import SignatureModal from "../components/SignatureModal.js";
import SignedSuccessModal from "../components/SignedSuccessModal.js";

var FillablePdf = function FillablePdf(_ref) {
  var pdfFileLink = _ref.pdfFileLink,
      annotationFields = _ref.annotationFields,
      _ref$viewOnly = _ref.viewOnly,
      viewOnly = _ref$viewOnly === void 0 ? false : _ref$viewOnly,
      _ref$signatureModalSi = _ref.signatureModalSize,
      signatureModalSize = _ref$signatureModalSi === void 0 ? 'lg' : _ref$signatureModalSi,
      successModalHeaderText = _ref.successModalHeaderText,
      SuccessModalBody = _ref.successModalBody,
      SuccessModalRedirectButton = _ref.successModalRedirectButton,
      template = _ref.template,
      index = _ref.index;

  var _useStores = useStores(),
      pdfStore = _useStores.pdfStore,
      signatureStore = _useStores.signatureStore;

  var selectedField = pdfStore.selectedField,
      signingDisabled = pdfStore.signingDisabled,
      reassigningFieldsEnabled = pdfStore.reassigningFieldsEnabled;
  var signatureModalOpen = signatureStore.signatureModalOpen,
      setSignatureModalOpen = signatureStore.setSignatureModalOpen,
      signField = signatureStore.signField;
  return jsx(Fillable, {
    viewOnly: viewOnly,
    signingDisabled: signingDisabled,
    reassigningFieldsEnabled: reassigningFieldsEnabled
  }, jsx(PdfDocument, {
    pdfFileLink: pdfFileLink,
    annotationFields: annotationFields,
    template: template,
    index: index
  }), jsx(SignatureModal, {
    isOpen: signatureModalOpen,
    onClose: function onClose() {
      return setSignatureModalOpen(false);
    },
    onSubmit: function onSubmit() {
      return signField(selectedField);
    },
    locale: "en",
    size: signatureModalSize
  }), jsx(SignedSuccessModal, {
    isOpen: pdfStore.signedSuccessModalOpen,
    onClose: function onClose() {
      return pdfStore.setSignedSuccessModalOpen(false);
    },
    modalHeaderText: successModalHeaderText,
    modalBodyContent: SuccessModalBody,
    redirectButton: SuccessModalRedirectButton
  }));
};

FillablePdf.displayName = "FillablePdf";
FillablePdf.propTypes = {
  pdfFileLink: _pt.string.isRequired,
  annotationFields: _pt.array.isRequired,
  viewOnly: _pt.bool,
  successModalHeaderText: _pt.string,
  signatureModalSize: _pt.string,
  index: _pt.number,
  children: _pt.node
};
var FillablePdf$1 = withStores(observer(FillablePdf));
export default FillablePdf$1;